var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGooglePlayBadgeEn(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    preserveAspectRatio: "xMidYMid meet",
    viewBox: "73.99999999999996 32.33333333333333 454.00000000000006 137.33333333333337",
    width: 450,
    height: 133.33,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M508.33 33.33C519.44 33.33 525 38.89 525 50C525 110 525 143.33 525 150C525 161.11 519.44 166.67 508.33 166.67C258.33 166.67 119.44 166.67 91.67 166.67C80.56 166.67 75 161.11 75 150C75 90 75 56.67 75 50C75 38.89 80.56 33.33 91.67 33.33C341.67 33.33 480.56 33.33 508.33 33.33Z",
    id: "eRp4V92WR"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M508.33 36C516.07 36 522.33 42.27 522.33 50C522.33 60 522.33 140 522.33 150C522.33 157.73 516.07 164 508.33 164C466.67 164 133.33 164 91.67 164C83.93 164 77.67 157.73 77.67 150C77.67 150 77.67 150 77.67 150C77.67 140 77.67 60 77.67 50C77.67 42.27 83.93 36 91.67 36C119.44 36 258.33 36 508.33 36M91.67 33.33C82.46 33.33 75 40.8 75 50C75 60 75 140 75 150C75 159.2 82.46 166.67 91.67 166.67C133.33 166.67 466.67 166.67 508.33 166.67C517.54 166.67 525 159.2 525 150C525 140 525 60 525 50C525 40.8 517.54 33.33 508.33 33.33C425 33.33 133.33 33.33 91.67 33.33Z",
    id: "b8fw8qmqBv"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M230.57 74.13C228.65 76.12 225.99 77.2 223.23 77.1C217.43 77.05 212.77 72.32 212.82 66.52C212.84 63.77 213.93 61.15 215.87 59.2C217.8 57.22 220.47 56.14 223.23 56.2C224.64 56.2 226.04 56.48 227.33 57.03C228.54 57.52 229.61 58.29 230.47 59.27C230.29 59.44 228.88 60.86 228.7 61.03C227.35 59.43 225.33 58.55 223.23 58.67C218.96 58.65 215.48 62.09 215.46 66.36C215.46 66.46 215.46 66.57 215.47 66.67C215.41 71.01 218.88 74.58 223.22 74.64C225.3 74.67 227.31 73.88 228.8 72.43C229.83 71.32 230.42 69.88 230.47 68.37C229.98 68.37 227.57 68.37 223.23 68.37L223.23 65.97C229.05 65.97 232.29 65.97 232.93 65.97C233.02 66.46 233.07 66.96 233.07 67.47C233.18 69.94 232.28 72.35 230.57 74.13ZM248.33 59.13L239.33 59.13L239.33 65.47L247.53 65.47L247.53 67.87L239.33 67.87L239.33 74.2L248.33 74.2L248.33 76.67L236.67 76.67L236.67 56.67L248.33 56.67L248.33 59.13ZM259.27 76.67L256.7 76.67L256.7 59.13L251.1 59.13L251.1 56.67L265 56.67L265 59.13L259.27 59.13L259.27 76.67ZM274.8 76.67L274.8 56.67L277.37 56.67L277.37 76.67L274.8 76.67ZM288.77 76.67L286.2 76.67L286.2 59.13L280.6 59.13L280.6 56.67L294.33 56.67L294.33 59.13L288.77 59.13L288.77 76.67ZM305.7 74.07C301.77 69.9 301.77 63.4 305.7 59.23C309.72 55.18 316.26 55.16 320.31 59.18C320.33 59.2 320.35 59.22 320.37 59.23C324.32 63.39 324.32 69.91 320.37 74.07C316.31 78.1 309.76 78.1 305.7 74.07ZM318.47 72.4C321.42 69.15 321.42 64.19 318.47 60.93C315.46 57.94 310.6 57.94 307.6 60.93C304.65 64.19 304.65 69.15 307.6 72.4C310.6 75.39 315.46 75.39 318.47 72.4ZM326.93 76.67L326.93 56.67L330.07 56.67L339.8 72.23L339.8 56.67L342.37 56.67L342.37 76.67L339.7 76.67L329.53 60.37L329.53 76.67L326.93 76.67Z",
    id: "b2e8iAbeug"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M288.03 120.07C288.07 127.89 294.44 134.2 302.27 134.17C310.06 134.13 316.37 127.8 316.37 120C316.48 112.29 310.32 105.94 302.6 105.83C302.45 105.83 302.29 105.83 302.13 105.83C294.31 105.87 288 112.24 288.03 120.07ZM292.95 120.62C292.62 115.88 296.2 111.77 300.93 111.44C305.67 111.11 309.78 114.68 310.11 119.42C310.13 119.61 310.13 119.81 310.13 120C310.36 124.52 306.87 128.37 302.35 128.59C302.27 128.6 302.2 128.6 302.13 128.6C297.4 128.93 293.29 125.36 292.95 120.62ZM256.97 120.03C256.99 127.86 263.34 134.18 271.17 134.17C278.98 134.15 285.3 127.81 285.3 120C285.41 112.29 279.25 105.94 271.54 105.83C271.38 105.83 271.22 105.83 271.07 105.83C263.28 105.85 256.95 112.21 256.97 120.03ZM261.89 120.66C261.54 115.92 265.1 111.8 269.83 111.45C274.57 111.1 278.69 114.65 279.04 119.39C279.06 119.59 279.07 119.8 279.07 120C279.29 124.52 275.8 128.37 271.28 128.59C271.21 128.6 271.14 128.6 271.07 128.6C266.36 128.95 262.24 125.39 261.89 120.66ZM234.13 110.2L234.13 116.2C242.77 116.2 247.57 116.2 248.53 116.2C248.31 119.03 247.13 121.69 245.2 123.77C242.29 126.73 238.26 128.33 234.1 128.17C225.26 128.17 218.1 121 218.1 112.17C218.1 103.33 225.26 96.17 234.1 96.17C238.16 96.1 242.08 97.65 245 100.47C245.42 100.04 248.81 96.66 249.23 96.23C245.25 92.2 239.8 89.95 234.13 90C221.97 89.53 211.73 99 211.26 111.16C210.79 123.32 220.26 133.56 232.42 134.03C232.99 134.06 233.56 134.06 234.13 134.03C239.91 134.29 245.51 132.05 249.5 127.87C252.99 124.03 254.86 118.99 254.7 113.8C254.71 112.54 254.6 111.28 254.37 110.03C251.67 110.06 244.92 110.11 234.13 110.2ZM385.17 114.87C383.39 109.63 378.56 106.04 373.03 105.83C365.67 105.82 359.69 111.78 359.67 119.14C359.67 119.43 359.68 119.71 359.7 120C359.53 127.66 365.61 134 373.26 134.16C373.43 134.17 373.6 134.17 373.77 134.17C378.5 134.19 382.94 131.84 385.57 127.9C385.08 127.57 381.22 124.9 380.73 124.57C379.27 127.01 376.62 128.51 373.77 128.5C370.81 128.61 368.09 126.91 366.9 124.2C368.16 123.68 374.49 121.07 385.87 116.37C385.49 115.57 385.26 115.07 385.17 114.87ZM365.83 119.6C365.55 115.32 368.8 111.62 373.08 111.34C373.13 111.34 373.18 111.34 373.23 111.33C375.43 111.19 377.5 112.37 378.5 114.33C375.97 115.39 368.37 118.55 365.83 119.6ZM350.43 133.33L356.67 133.33L356.67 91.67L350.43 91.67L350.43 133.33ZM340.23 109C340.09 109 340.02 109 340 109C338.1 106.88 335.38 105.66 332.53 105.67C324.7 106.05 318.66 112.7 319.04 120.54C319.39 127.84 325.23 133.68 332.53 134.03C335.39 134.08 338.13 132.86 340 130.7C340.01 130.7 340.08 130.7 340.2 130.7C340.2 131.92 340.2 132.6 340.2 132.73C340.2 138.17 337.3 141.07 332.63 141.07C329.45 140.99 326.64 139 325.5 136.03C324.96 136.26 320.61 138.07 320.07 138.3C322.16 143.39 327.13 146.7 332.63 146.67C339.93 146.67 345.97 142.37 345.97 131.9C345.97 130.22 345.97 121.81 345.97 106.67L340.23 106.67L340.23 109ZM325.26 119.24C325.63 115.07 328.93 111.77 333.1 111.4C337.51 111.63 340.91 115.39 340.68 119.8C340.68 119.87 340.67 119.93 340.67 120C341.04 124.37 337.8 128.21 333.43 128.58C333.31 128.59 333.19 128.6 333.07 128.6C328.35 128.18 324.84 123.99 325.26 119.24ZM399.47 91.67L399.47 133.33L405.7 133.33L405.7 117.53C410.92 117.53 413.82 117.53 414.4 117.53C421.54 118.05 427.75 112.67 428.26 105.53C428.78 98.39 423.4 92.18 416.26 91.67C415.64 91.62 415.02 91.62 414.4 91.67C414.4 91.67 409.42 91.67 399.47 91.67ZM414.37 111.67L405.67 111.67L405.67 97.47C410.97 97.47 413.91 97.47 414.5 97.47C418.45 97.47 421.65 100.67 421.65 104.62C421.65 108.57 418.45 111.77 414.5 111.77C414.5 111.77 414.5 111.77 414.5 111.77C414.48 111.75 414.44 111.72 414.37 111.67ZM452.8 105.67C448.16 105.39 443.8 107.89 441.7 112.03C442.25 112.26 446.68 114.1 447.23 114.33C448.35 112.28 450.57 111.08 452.9 111.27C456.19 110.88 459.17 113.24 459.56 116.53C459.56 116.56 459.56 116.6 459.57 116.63C459.57 116.68 459.57 117.02 459.57 117.07C457.56 116.01 455.33 115.46 453.07 115.47C447.1 115.47 441.07 118.8 441.07 124.83C441.31 130.15 445.82 134.26 451.13 134.02C451.22 134.01 451.31 134.01 451.4 134C454.6 134.23 457.67 132.7 459.4 130C459.41 130 459.48 130 459.6 130L459.6 133.33L465.6 133.33C465.6 123.71 465.6 118.37 465.6 117.3C465.6 110 460.07 105.77 452.97 105.77C452.93 105.75 452.83 105.69 452.8 105.67ZM452.03 128.5C450 128.5 447.17 127.47 447.17 124.97C447.17 121.63 450.7 120.53 453.83 120.53C455.81 120.48 457.77 120.97 459.5 121.93C459.07 125.66 455.96 128.51 452.2 128.6C452.17 128.58 452.07 128.52 452.03 128.5ZM487.47 106.67L480.33 124.73L480.13 124.73L472.73 106.67L466.07 106.67L477.17 131.93L470.83 145.97L477.33 145.97L494.4 106.67L487.47 106.67ZM431.43 133.33L437.67 133.33L437.67 91.67L431.43 91.67L431.43 133.33Z",
    id: "dXaQHMtXd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M109.8 58.47C108.71 59.77 108.17 61.44 108.27 63.13C108.27 70.51 108.27 129.49 108.27 136.87C108.17 138.56 108.71 140.23 109.8 141.53C109.82 141.55 109.89 141.63 110.03 141.77L151.33 100.5L151.33 99.53L110.03 58.23C109.91 58.36 109.83 58.44 109.8 58.47Z",
    id: "bdLwWs2Wd"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradienta12xK1yelT",
    gradientUnits: "userSpaceOnUse",
    x1: 147.67,
    y1: 62.37,
    x2: 91.73,
    y2: 118.3
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#00a0ff",
      stopOpacity: 1
    },
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#00a1ff",
      stopOpacity: 1
    },
    offset: "1%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#00beff",
      stopOpacity: 1
    },
    offset: "26%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#00d2ff",
      stopOpacity: 1
    },
    offset: "51%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#00dfff",
      stopOpacity: 1
    },
    offset: "76%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#00e3ff",
      stopOpacity: 1
    },
    offset: "100%"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M165 114.27L151.33 100.5L151.33 99.53L165 85.73L165.3 85.9C175.12 91.48 180.58 94.58 181.67 95.2C186.33 97.83 186.33 102.17 181.67 104.83C180.58 105.45 175.15 108.54 165.37 114.1L165 114.27Z",
    id: "a1320wSXnl"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradientckE1lH7dt",
    gradientUnits: "userSpaceOnUse",
    x1: 187.77,
    y1: 100,
    x2: 107.13,
    y2: 100
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffe000",
      stopOpacity: 1
    },
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffbd00",
      stopOpacity: 1
    },
    offset: "41%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ffa500",
      stopOpacity: 1
    },
    offset: "78%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ff9c00",
      stopOpacity: 1
    },
    offset: "100%"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M165.4 114.07L151.33 100C126.41 124.92 112.57 138.76 109.8 141.53C111.76 143.26 114.67 143.34 116.73 141.73C119.98 139.89 136.21 130.67 165.43 114.07",
    id: "c3zMJDdY4A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradienta1HilVRGI",
    gradientUnits: "userSpaceOnUse",
    x1: 157.77,
    y1: 107.67,
    x2: 81.9,
    y2: 183.5
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#ff3a44",
      stopOpacity: 1
    },
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#c31162",
      stopOpacity: 1
    },
    offset: "100%"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M165.4 85.93C136.18 69.33 119.95 60.11 116.7 58.27C114.64 56.66 111.73 56.74 109.77 58.47C112.54 61.24 126.39 75.08 151.33 100L165.4 85.93Z",
    id: "fTGJ43Psc"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradienta2be5VbJvz",
    gradientUnits: "userSpaceOnUse",
    x1: 99.33,
    y1: 33.93,
    x2: 133.2,
    y2: 67.8
  }, /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#32a071",
      stopOpacity: 1
    },
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#2da771",
      stopOpacity: 1
    },
    offset: "7.000000000000001%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#15cf74",
      stopOpacity: 1
    },
    offset: "48%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#06e775",
      stopOpacity: 1
    },
    offset: "80%"
  }), /*#__PURE__*/React.createElement("stop", {
    style: {
      stopColor: "#00f076",
      stopOpacity: 1
    },
    offset: "100%"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M165 113.77C136.02 130.27 119.92 139.43 116.7 141.27C114.72 142.74 112.01 142.74 110.03 141.27C110.02 141.28 109.94 141.36 109.8 141.5C109.94 141.64 110.02 141.72 110.03 141.73C112.01 143.22 114.73 143.22 116.7 141.73C119.95 139.89 136.18 130.67 165.4 114.07L165 113.77Z",
    id: "a76ZCvcDlN"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M109.8 141.07C108.71 139.76 108.17 138.09 108.27 136.4C108.27 136.45 108.27 136.85 108.27 136.9C108.17 138.59 108.71 140.26 109.8 141.57C109.82 141.55 109.89 141.47 110.03 141.33C109.91 141.19 109.83 141.1 109.8 141.07ZM165 113.77L165.3 114.07C175.12 108.51 180.58 105.42 181.67 104.8C183.56 103.91 184.83 102.08 185 100C184.62 101.88 183.39 103.48 181.67 104.33C179.44 105.59 173.89 108.74 165 113.77Z",
    id: "dJ8LkmpNa"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M181.67 95.67C183.39 96.52 184.62 98.12 185 100C184.83 97.92 183.56 96.09 181.67 95.2C175.17 91.51 123.2 61.96 116.7 58.27C112.03 55.63 108.23 57.83 108.23 63.17C108.23 63.22 108.23 63.62 108.23 63.67C108.33 58.3 112.07 56.1 116.7 58.73C129.69 66.12 175.17 91.97 181.67 95.67Z",
    id: "btPvkMc5S"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#eRp4V92WR",
    opacity: 1,
    fill: "#000000",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#eRp4V92WR",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b8fw8qmqBv",
    opacity: 1,
    fill: "#a6a6a6",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b8fw8qmqBv",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b2e8iAbeug",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b2e8iAbeug",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#ffffff",
    strokeWidth: 0.2,
    strokeOpacity: 1
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dXaQHMtXd",
    opacity: 1,
    fill: "#ffffff",
    fillOpacity: 1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#dXaQHMtXd",
    opacity: 1,
    fillOpacity: 0,
    stroke: "#000000",
    strokeWidth: 1,
    strokeOpacity: 0
  }))), /*#__PURE__*/React.createElement("g", {
    id: "New-White-Icon"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinejoin: "miter",
    d: "M109.8 58.47C108.71 59.77 108.17 61.44 108.27 63.13C108.27 70.51 108.27 129.49 108.27 136.87C108.17 138.56 108.71 140.23 109.8 141.53C109.82 141.55 109.89 141.63 110.03 141.77L151.33 100.5L151.33 99.53L110.03 58.23C109.91 58.36 109.83 58.44 109.8 58.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinejoin: "miter",
    d: "M165 114.27L151.33 100.5L151.33 99.53L165 85.73L165.3 85.9C175.12 91.48 180.58 94.58 181.67 95.2C186.33 97.83 186.33 102.17 181.67 104.83C180.58 105.45 175.15 108.54 165.37 114.1L165 114.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinejoin: "miter",
    d: "M165.4 114.07L151.33 100C126.41 124.92 112.57 138.76 109.8 141.53C111.76 143.26 114.67 143.34 116.73 141.73C119.98 139.89 136.21 130.67 165.43 114.07"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    stroke: "#000000",
    strokeWidth: 3,
    strokeLinejoin: "miter",
    d: "M165.4 85.93C136.18 69.33 119.95 60.11 116.7 58.27C114.64 56.66 111.73 56.74 109.77 58.47C112.54 61.24 126.39 75.08 151.33 100L165.4 85.93Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGooglePlayBadgeEn);
export default __webpack_public_path__ + "static/media/google-play-badge_en.8b7c6a01c4f154594d296f61ed0dd79e.svg";
export { ForwardRef as ReactComponent };